import { useModelGroupsQuery } from '../api/useModelGroupsQuery';
import { useDefaultAssetAllocation } from './useDefaultAssetAllocation';
import { getAssetAllocationColors } from './getAssetAllocationColors';

export const useAssetsColors = () => {
  const { data } = useModelGroupsQuery();

  const defaultAssetAllocation = useDefaultAssetAllocation();

  if (!data || !defaultAssetAllocation) {
    return null;
  }

  return getAssetAllocationColors({ assetAllocation: defaultAssetAllocation });
};
